import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {VRGroupService} from '../../vrgroup.service';
import {takeUntil} from 'rxjs/operators';
import {BaseComponent} from '../../../../components/general/base/base.component';
import { LiviCauseCode, formatLiviCauseCode } from '../../common/konegis-cause-code';

@Component({
  selector: 'qm-vrgroup-cause-dashboard',
  templateUrl: './cause-dashboard.component.html',
  styleUrls: ['./cause-dashboard.component.scss']
})
export class CauseDashboardComponent extends BaseComponent implements OnInit, OnDestroy {

  public causes: { cause: string, count: number }[];
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<boolean> = new Subject();

  constructor(private vrGroupService: VRGroupService,
              private changeDetector: ChangeDetectorRef) {
    super();
    this.name = 'CauseDashboard';
  }

  ngOnInit() {
    this.vrGroupService.causes$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
      this.updateCauseArray(result);
      this.loading = false;
      this.changeDetector.markForCheck();
    });
  }

  /**
   * Angular destructor function
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateCauseArray(causeMap: Map<string, number>) {
    this.causes = Array.from(causeMap.entries())      // Converts Map to array of "tuples" [ [key, value], [key, value], etc...]
                    .filter((value: [string, number]) => value[0].charAt(0) !== 'E') // Filter out E codes
                    .sort((a, b) => b[1] - a[1])      // Sort descending by value field
                    .slice(0, 10)                     // Take 10 first (-> largest) items
                    .map((value: any[]) => {
                      const code: string = value[0];  // Use liviCode to get the record from vrGroupService
                      const liviCauseCode: LiviCauseCode = this.vrGroupService.findLiviCauseCode(code);
                      // If the category name is undefined, display the code
                      const causeText: string = formatLiviCauseCode(code, liviCauseCode);
                      return { cause: causeText, count: value[1] };
                    });
    console.log(this.causes);
  }

}
